import { render } from "./SetHeader.vue?vue&type=template&id=3c3c6060&scoped=true"
import script from "./SetHeader.vue?vue&type=script&lang=js"
export * from "./SetHeader.vue?vue&type=script&lang=js"

import "./SetHeader.vue?vue&type=style&index=0&id=3c3c6060&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3c6060"]])

export default __exports__